<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="reporting"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>{{ headerMessage }}</b>
              </span>
            </nav>
            <div
              class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm"
                  >Salesperson Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  v-model="selectedName"
                  class="form-control input-sm"
                  @[change]="displayTasks()"
                  :disabled="salesAgentOnly"
                >
                  <option value="All">All</option>
                  <option
                    v-for="(option, index) in employeelist"
                    :value="option.employeeId"
                    :key="index"
                    >{{ option.firstName }}
                    {{
                      option.middleName.length != 0
                        ? "," + option.middleName
                        : ""
                    }}
                    , {{ option.lastName }}</option
                  >
                </select>
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm"
                  >Select Week</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  v-model="selectedWeek"
                  @[change]="displayTasks"
                  class="form-control input-sm"
                >
                  <option
                    v-for="(option, index) in weekList"
                    :value="option.key"
                    v-bind:key="option.key"
                    :key="index"
                    >{{ option.value }}</option
                  >
                </select>
              </div>
            </div>
            <br />
            <br />
            <div>
              <div class="row p-2 justify-content-center">
                <div class="col">
                  <div
                    class="table-responsive table-responsive-sm mb-5"
                    style="overflow:auto;"
                  >
                    <v-table
                      id="myappsTable"
                      :data="taskList"
                      :currentPage.sync="currentPage"
                      :pageSize="5"
                      @totalPagesChanged="totalPages = $event"
                      class="table table-sm table-bordered table-striped"
                    >
                      <thead
                        class="table-month-header-blue wrap-text"
                        slot="head"
                      >
                        <v-th sortKey="startOfWeek">Schedule Week</v-th>
                        <v-th sortKey="employee.firstName"
                          >Salesperson Name</v-th
                        >
                        <v-th sortKey="activityTaskX">Activity Task</v-th>
                        <v-th sortKey="dealerName">Dealer Name</v-th>
                        <v-th sortKey="eventType">Event Type</v-th>
                        <v-th sortKey="agentTaskNotes">Notes</v-th>
                        <v-th sortKey="lastUpdatedD">Task Updated Date</v-th>
                      </thead>
                      <tbody slot="body" slot-scope="{ displayData }">
                        <tr v-for="task in displayData">
                          <td class="table-month-td">
                            {{ task.startOfWeek | moment("MM/DD/YYYY") }} to
                            {{ task.endOfWeek | moment("MM/DD/YYYY") }}
                          </td>
                          <td class="table-month-td">
                            {{ task.employee.firstName }},{{
                              task.employee.lastName
                            }}
                          </td>
                          <td class="table-month-td">
                            {{ task.activityTaskX }}
                          </td>
                          <td class="table-month-td">{{ task.dealerName }}</td>
                          <td class="table-month-td">{{ task.eventType }}</td>
                          <td class="table-month-td">
                            {{ task.agentTaskNotes }}
                          </td>
                          <td class="table-month-td">
                            {{
                              task.lastUpdatedD | moment("MM/DD/YYYY hh:mm:ss")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee'
import httptask from '../js/http-addtask.js'
import moment from 'moment'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      selectedName: 'All',
      taskList: [],
      // norecordsfound:'true',
      salesAgentOnly: false,
      headerMessage: 'View Salesperson Task',
      name: '',
      users: [],
      currentPage: 1,
      totalPages: 0,
      selectedWeek: 'CUR',
      weekList: [
        {
          key: 'CUR',
          value: 'Current Week'
        },
        {
          key: 'WK2',
          value: 'Last 2 Weeks'
        },
        {
          key: 'WK3',
          value: 'Last 3 Weeks'
        },
        {
          key: 'WK4',
          value: 'Last 4 Weeks'
        },
        {
          key: 'WK8',
          value: 'Last 8 Weeks'
        }
      ],
      employeelist: [],
      tasklist: [],
      weekstart: moment().weekday(0),
      weekend: moment().weekday(6),
      task: this.initializedata(),
      datas: [
        'Schedule Week',
        'Salesperson Name',
        'Activity Task',
        'Dealer Name',
        'Event Type',
        'Notes',
        'Task Updated Date'
      ]
    }
  },
  methods: {
    initializedata () {
      return {
        empId:
          this.$session.get('user_role') == 'SR'
            ? this.$session.get('employee_id')
            : ''
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    searchTasks: function () {
      this.retreiveSelectedSalesRepData()
    },
    retreiveAgentList: function () {
      httpemployee
        .get('/employee/salesrep')
        .then(response => {
          this.employeelist = response.data
          this.task.empId = 'All'
          if (this.$session.get('user_role') === 'SR') {
            this.task.empId = this.$session.get('employee_id')
            this.salesAgentOnly = true
          } else {
            this.salesAgentOnly = false
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    displayTasks: function () {
      if (this.selectedWeek == 'CUR' && this.selectedName == 'All') {
        var daystoadinstart = 0
        var viewTaskPayload = {
          fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
          toDate: moment(this.weekend)
        }
      } else if (this.selectedWeek == 'WK2' && this.selectedName == 'All') {
        var daystoadinstart = 7
        var viewTaskPayload = {
          fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
          toDate: moment(this.weekend)
        }
      } else if (this.selectedWeek == 'WK3' && this.selectedName == 'All') {
        var daystoadinstart = 14
        var viewTaskPayload = {
          fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
          toDate: moment(this.weekend)
        }
      } else if (this.selectedWeek == 'WK4' && this.selectedName == 'All') {
        console.log(this.selectedName)
        var daystoadinstart = 21
        var viewTaskPayload = {
          fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
          toDate: moment(this.weekend)
        }
      } else if (this.selectedWeek == 'WK8' && this.selectedName == 'All') {
        var daystoadinstart = 49
        var viewTaskPayload = {
          fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
          toDate: moment(this.weekend)
        }
      } else {
        if (this.selectedWeek == 'CUR') {
          var viewTaskPayload = {
            repId: this.selectedName,
            fromDate: moment(this.weekstart),
            toDate: moment(this.weekend)
          }
        }
        if (this.selectedWeek == 'WK2') {
          var daystoadinstart = 7
          var viewTaskPayload = {
            repId: this.selectedName,
            fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
            toDate: moment(this.weekend)
          }
        }
        if (this.selectedWeek == 'WK3') {
          var daystoadinstart = 14
          var viewTaskPayload = {
            repId: this.selectedName,
            fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
            toDate: moment(this.weekend)
          }
        }
        if (this.selectedWeek == 'WK4') {
          var daystoadinstart = 21
          var viewTaskPayload = {
            repId: this.selectedName,
            fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
            toDate: moment(this.weekend)
          }
        }
        if (this.selectedWeek == 'WK8') {
          var daystoadinstart = 49
          var viewTaskPayload = {
            repId: this.selectedName,
            fromDate: moment(this.weekstart).subtract(daystoadinstart, 'days'),
            toDate: moment(this.weekend)
          }
        }
      }
      if (this.$session.get('user_role') === 'SR') {
        this.selectedName = this.$session.get('employee_id')
        var viewTaskPayload = {
          repId: this.$session.get('employee_id'),
          fromDate: moment(this.weekstart),
          toDate: moment(this.weekend)
        }
      }
      httptask.post('/searchtasks', viewTaskPayload).then(response => {
        this.taskList = response.data
      })
    },
    dispalyemployee () {},
    retreiveSelectedSalesRepData: function () {
      if (this.task.empId !== 'All') {
        httptask
          .get('/employee/' + this.task.empId)
          .then(response => {
            // console.log("Search Results:"+ JSON.stringify(response.data))
            if (response.data.length != 0) {
              // this.norecordsfound = false;
              this.tasklist = response.data
            } else {
              // this.norecordsfound = true;
              this.tasklist = []
            }
          })
          .catch(e => {
            console.log('Failed to get Tasks for Sales Rep')
            // this.norecordsfound = true;
            this.tasklist = []
          })
      }
    },
    fetchdata: function () {
      this.displayTasks()
      this.retreiveAgentList()
      if (this.$session.get('user_role') === 'SR') {
        this.retreiveSelectedSalesRepData()
      }
    }
  },
  /* computed: {
	    filteredTaskList: function (){
	        var firstName = this.selectedName;
	        var lastName = this.selectedName;

	        var daystoadinstart=0;
	       if(this.selectedWeek=="CUR"){
	           daystoadinstart=0;
	       }
	       else if(this.selectedWeek=="WK2"){
	           daystoadinstart=7;
	       }
	       else if(this.selectedWeek=="WK3"){
	           daystoadinstart=14;
	       }
	       else if(this.selectedWeek=="WK4"){
	           daystoadinstart=21;
	       }
	       else if(this.selectedWeek=="WK8"){
	           daystoadinstart=49;
	       }
	         var startofWeekonScreen =  moment(this.weekstart).subtract(daystoadinstart,'days').format('MM/DD/YYYY');
	        var endofWeekonScreen =  moment(this.weekend).format('MM/DD/YYYY');
	       return this.tasklist.filter(function(tasks){

	      console.log((moment(tasks.startOfWeek)).format('MM/DD/YYYY'))
	      return ((moment(tasks.startOfWeek)).format('MM/DD/YYYY') >= startofWeekonScreen  &&  moment(tasks.endOfWeek).format('MM/DD/YYYY')<= endofWeekonScreen  );
	        })

	}
        }, */
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted: function () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped></style>
